import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import TasCommentsContent, { AddCommentForm } from '../../comments/content.gts';
import type TasApplicationModel from '../../../../models/tas-application.ts';
import type PersonModel from '../../../../models/person.ts';
import type UserModel from '../../../../models/user.ts';
import type { DrawerContext } from '../types.ts';

/**
 * Comments drawer content component
 * Wraps TasCommentsContent for application comments
 */
export interface CommentsDrawerSignature {
  Args: {
    drawer: DrawerContext;
    model: TasApplicationModel;
    authoredByPerson: PersonModel;
    authoredByUser: UserModel;
    commentTags?: string[];
  };
}

class CommentsDrawer extends Component<CommentsDrawerSignature> {
  @tracked activeTab: 'approver' | 'employee' = 'approver';

  get commentTags() {
    return this.activeTab === 'approver' ? ['approver'] : ['Partner Messaging'];
  }

  handleTabChange = (tab: 'approver' | 'employee') => {
    this.activeTab = tab;
  };

  <template>
    <div class="flex flex-col h-full">
      <@drawer.Header class="flex-none">
        <h2 class="text-lg font-semibold text-gray-800">{{t
            "tuition_assistance.application_approval.comments"
          }}</h2>
      </@drawer.Header>
      <@drawer.Body class="flex-1 overflow-y-auto">
        <TasCommentsContent
          @commentable={{@model}}
          @commentableType="TasApplication"
          @authoredByPerson={{@authoredByPerson}}
          @authoredByUser={{@authoredByUser}}
          @commentTags={{array "approver"}}
          @hideAddCommentForm={{true}}
          @onTabChange={{this.handleTabChange}}
        />
      </@drawer.Body>
      <@drawer.Footer class="flex-none p-4 border-t border-gray-200 bg-white w-full">
        <AddCommentForm
          @commentable={{@model}}
          @commentableType="TasApplication"
          @authoredByPerson={{@authoredByPerson}}
          @commentTags={{this.commentTags}}
          @inDrawer={{true}}
        />
      </@drawer.Footer>
    </div>
  </template>
}

export default CommentsDrawer;
